import { useCallback } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { ShieldCheck } from 'lucide-react';

const stripePromise = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  ? loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
  : null;

export function EmbeddedCheckoutModal({ open, clientSecret, onComplete, onClose, title = 'Complete payment' }) {
  const handleComplete = useCallback(() => { if (onComplete) onComplete(); }, [onComplete]);

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-xl p-0 overflow-hidden gap-0" data-testid="embedded-checkout-modal">
        <DialogHeader className="px-5 pt-5 pb-3 border-b border-slate-100">
          <DialogTitle className="text-base">{title}</DialogTitle>
          <DialogDescription className="text-xs flex items-center gap-1.5 text-slate-500">
            <ShieldCheck className="w-3.5 h-3.5 text-emerald-500" /> Secure payment by Stripe — you won't leave this page.
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[72vh] overflow-auto p-3" data-testid="embedded-checkout-mount">
          {open && clientSecret && stripePromise && (
            <EmbeddedCheckoutProvider
              stripe={stripePromise}
              options={{ clientSecret, onComplete: handleComplete }}
            >
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}
          {open && !stripePromise && (
            <p className="text-sm text-red-500 p-4">Stripe publishable key is not configured.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
